import { AnimeApiFormatCapituleList } from "./animeApi"
import { API_CAPITULE } from "./settings"

const fromAnimeApiResponsetoCapitule = apiResponse => {

    return AnimeApiFormatCapituleList(apiResponse?.data);
}
const serviceCapitule = (id) => {
    return fetch(`${API_CAPITULE}${id}&is_dub=true&locale=en`)
        .then(res => res.json())
        .then(fromAnimeApiResponsetoCapitule)
        .catch((err) => { console.error('⚠ Algo Salio mal 😪', err) })
}
export default serviceCapitule;